import React from "react";

function SortDown() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path stroke="#000" strokeWidth="1" d="M15 8l-5 4-5-4"></path>
    </svg>
  );
}

export default SortDown;
